export default {
        totalaftervat: "اجمالي بعد القيمة المضافة",
        totalvat: "القيمة المضافة",
        totalaftertax: "اجمالي بعد الضرائب",
        totaltax: "اجمالي الضرائب",
        fees: "الرسوم الإضافية",
        enttax: "ضريبة الترفيه",
        totalgross: "اجمالي دخول",
        totaltickets: "عدد التذاكر",
        ticketnet: "صافي التذكرة",
        ticketprice: "فئه التذكرة (مقابل الدخول)",
        movie: "الفيلم",
        screen: "شاشة العرض",
        showTime: "وقت العرض",
        showdate: "التاريخ",
        socialsubside: "بر",
        cinemasubside: "سينما ",
        policesubside: "شرطه",
        daransubside: "درن",
        //cinema tax vat analysis report
        servicessubside: "خدمات",
        sports: "الرياضة",
        grandtotal: "ا ﺟ ﻤ ﺎ ﻟ ",
        total: "ا ﺟ ﻤ ﺎ ﻟ ",
        distributioncompany: "شركة التوزيع",
        distributionname: "شركة التوزيع",
        ticketcosttotal: "فئة التذكرة (اجمالي)",
        ticketcostforentry: "فئة التذكرة (مقابل الدخول)",
        ticketscount: "عدد التذاكر",
        ticketscost: "اجمالي دخول",
        amusementtax: "ملاهي",
        taxtotal: "اجمالي الضرائب",
        totalafterasumetax: "صافي بعد القيمة المضافة",
        vat: "القيمة المضافة",
        netaftervat: "صافي بعد القيمة المضافة",
        tax: "الضريبة",
        //cinema tax screen analyis
        productioncompany: "شركة الإنتاج",
        type: "نوع",
        egyptian: "مصرى",
        foreign: "أجنبي",
        finalreport: "التقرير النهائي ",
        ongoingreserve: " الحجز الجاري",
        //cinema overall analyisis
        ticketscosttotal: "تكلفة التذاكر (إجمالي)",
        ticketscostforentry: "تكلفة التذاكر (للدخول)",
        total: "الإجمالي",
        grandtotal: "الإجمالي الكلي",
        ticket_quantity: "كمية التذاكر",
        ticket_price: "سعر التذكرة",
        reprint_qty: "كمية إعادة الطباعة",
        authorized_by: "مصرح به من قبل",
        show_date: "تاريخ العرض",
        show_time: "وقت العرض",
        ref_code: "رمز المرجع",
        selling_time: "وقت البيع",
        screen: "الشاشة",
        movie: "الفيلم",
        reprint_time: "إعادة طباعة التاريخ والوقت",
        ticketSerialNo: "رقم التذكرة التسلسلي",
        user: "مستخدم",
        refundTime: "تاريخ استرداد الأموال",
        sellTime: "بيع التاريخ الوقت",
        //transaction refund report
        transactionnumber: "رقم المعاملة",
        bookingdate: "تاريخ البيع/الوقت",
        date: "التاريخ",
        filmname: "اسم الفيلم",
        screenname: "اسم الشاشة",
        salesChannel: "قناة المبيعات",
        seatnumber: "رقم المقعد",
        refundamount: "مبلغ الاسترداد",
        refunddatetime: "تاريخ ووقت الاسترداد",
        minutesaftersessionstarted: "الدقائق بعد بدء الجلسة",
        refundreason: "سبب الاسترداد",
        refundedby: "تم الاسترداد بواسطة",
        authorizedby: "تم التفويض بواسطة",
        paymentmode: "طريقة الدفع",
        customername: "اسم العميل",
        mobileno: "رقم الهاتف المحمول",
        boremarks: "ملاحظات بو",
        refundTime: "وقت الاسترداد",
        sellTime: "وقت البيع",
        //cashier settlement report
        showtimes: "أوقات العرض",
        tickets: "تذاكر",
        ticketsrevenue: "إيرادات التذاكر",
        "3dglasses": "نظارات ثلاثية الأبعاد",
        "3dglassesrevenue": "إيرادات نظارات ثلاثية الأبعاد",
        paymentmethods: "طرق الدفع",
        cashier: "أمين الصندوق",
        bookingchannels: "قنوات الحجز",
//movie overall anlysis Report
        moviename: "الفيلم",
        distributorcompany: "شركة التوزيع",
        totaltickets: "عدد التذاكر",
        totalticketsprice: "اجمالي دخول",
        totaltaxes: "اجمالى الضرائب",
        totalvat: "القيمة المضافة",
        totalnet: "صافي بعد القيمة المضافة",      
        totalPrice: "القيمة",
        concessionHardware: "الكافيتريا",
        posUsername: "مستخدم نقطة البيع",
        qty: "الكمية",
        item: "الصنف",
        username: "Username",
        fnbCourtseyReport: "تقرير مجاملات الأغذية والمشروبات",
        overAllTotal : "على الكل المجموع",
        refundedby: "بواسطة",
        approver: "المعتمد",
        personalName: "اسم الضيافة",
        refunddatetime: "التاريخ",
        datetime: "التاريخ",
        showDateTime: "عرض التاريخ/الوقت",
        serialNo: "رقم سري",
        noOfTickets: "عدد التذاكر",
        ticketPrice: "سعر التذاكر",
        forDays: "لعدة أيام",
        netProfit: "الربح",
        cost: "التكلفة",
        resone: "السبب",
        total: "إجمالى",
        quantity: "الكمية",
        price: "السعر",
        date: "التاريخ",
        itemName: "سنكرس",
        totalCost: "اجمالى",
        stock: "الرصيد",
        item: "الصنف",
        totalSoldTicket: "مباعه تذاكر ج",
        TotalSoldTicketsRevenue: "ه تذاكر سعر ج",
        TotalSold3DGlasses: "ه نظارات ج",
        TotalSold3DGlassesRevenue: "ع نظارات سعر ج",
        TotalPurgedTickets: "مرتجع تذاكر ج",
        TotalPurgedTicketsRevenue: "مرتجع تذاكر سعر ج",
        TotalPurged3DGlasses: "ع نظارات ج",
        TotalPurged3DGlassesRevenue: "مرتجع نظارات سعر ج",
        TotalSoldTickets: "ج تذاكرمباعه",
        TotalSoldTicketsRevenue: "ج سعرتذاكر مباعه",
        TotalSold3DGlasses: "ج نظاراتمباعه",
        TotalSold3DGlassesRevenue: "ج سعرنظاراتمباع",
        TotalTicketsGlassesRevenue: "اجمالىسعر",
        Additionalfees:"رسوم اضافيه",

         Cost_balance: "الفيلم",
          Total_Cost: "التكلفة",
          Item_Cost:   "ت الوحدة",
          Item_Request_Form_no:   "اذن رقم",
          Reason: "السبب",
          Stock: "الرصيد",
          Spend: "منصرف",
          Import: "وارد",
          Purchase_Return:   "عائد الشراء",
          Transfer_In: "نقل",
          Property_In:   "الملكية في",
          Property_Out:   "الملكية خارج",
          Standard_Consumed:   "المستهلكة القياسية",
          Wastage: "الهدر",
          Variance: "التباين",
          System_Stock:   "مخزون النظام",
          Date: "التاريخ",
          SubWare_House:  "سعر التذكرة",
          Main_Ware_House:   "كمية التذاكر",
          distirbutor_share_value: "قيمة حصة الموزع",


}


// WEBPACK FOOTER //
// ./src/helper/trans/ar.js